import React from 'react';
import { Link } from 'react-router-dom';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { routeConstants } from 'app/routes/route-constants';

export const addLinkFactory = (label: string, breadcrumbs: number[], parentId: number, duplicateId?: number) => {
  return <Link to={isDefinedIncludingZero(duplicateId)
    ? routeConstants.codetableAdministrationDuplicateCodeFor(breadcrumbs, duplicateId)
    : routeConstants.codetableAdministrationAddCodeFor(breadcrumbs, parentId)}
    className="dropdown-item">
    {label}
  </Link>;
};
